const buttons = () => {
  const buttons = document.querySelectorAll(".button, .navbar-buttons a");
  buttons.forEach((button) => {
    let inner = button.innerHTML;

    if (button.classList.contains("webform-button--submit")) {
      inner = '<i class="fa-light fa-envelope"></i>' + inner;
    } else if (button.classList.contains("form-submit")) {
      inner = '<i class="fa-light fa-right-to-bracket"></i>' + inner;
    }

    button.innerHTML = `<span>${inner}</span><span>${inner}</span>`;
  });
};

export default buttons;
